import { z } from "zod";
import { washActivationStatusSchema, washCycleStatusSchema, washCycleTriggerSchema, washUnitStateSchema, washWorkOrderStatusSchema, } from "../wash/enums.js";
import { defineEvent } from "./registry.js";
/**
 * Yıkama olayları (Prompt 18, ADR 0018 §21). Yük KİŞİSEL VERİ TAŞIMAZ: plaka / ad / telefon / kod YOK — yalnızca kimlikler,
 * durumlar ve tutar / saniye dizgeleri. Zarf `metadata.stationId` taşır → istasyon odası (sıra ekranı, ünite panosu).
 */
const money = z.string().regex(/^-?\d{1,19}$/);
const base = { companyId: z.uuid(), stationId: z.uuid() };
export const washCycleRecordedV1 = defineEvent({
    type: "wash.cycle.recorded",
    version: 1,
    description: "Yıkama makinesi çalışması kaydedildi (kimyasal tüketimi worker'la stok defterine yazılır)",
    realtime: ["station"],
    payload: z.object({
        ...base,
        cycleId: z.uuid(),
        unitId: z.uuid().nullable(),
        programId: z.uuid().nullable(),
        trigger: washCycleTriggerSchema,
        status: washCycleStatusSchema,
        durationSeconds: z.number().int(),
        /** Yalnızca makinenin kendi tahsilatında (KDV dahil, kuruş). */
        amount: money.nullable(),
    }),
});
export const washUnitFaultStartedV1 = defineEvent({
    type: "wash.unit.fault_started",
    version: 1,
    description: "Yıkama ünitesi arızaya geçti",
    realtime: ["tenant", "station"],
    payload: z.object({
        ...base,
        unitId: z.uuid(),
        faultCode: z.string().nullable(),
        at: z.iso.datetime({ offset: true }),
    }),
});
export const washUnitFaultClearedV1 = defineEvent({
    type: "wash.unit.fault_cleared",
    version: 1,
    description: "Yıkama ünitesinin arızası giderildi (süre saniye)",
    realtime: ["tenant", "station"],
    payload: z.object({
        ...base,
        unitId: z.uuid(),
        faultCode: z.string().nullable(),
        durationSeconds: z.number().int(),
    }),
});
export const washUnitStatusChangedV1 = defineEvent({
    type: "wash.unit.status_changed",
    version: 1,
    description: "Yıkama ünitesinin durumu değişti (canlı pano)",
    realtime: ["station"],
    payload: z.object({
        ...base,
        unitId: z.uuid(),
        state: washUnitStateSchema,
        faultCode: z.string().nullable(),
    }),
});
export const washActivationChangedV1 = defineEvent({
    type: "wash.activation.changed",
    version: 1,
    description: "Yıkama başlatma isteğinin durumu değişti (başladı / başlatılamadı / süresi doldu)",
    realtime: ["station"],
    payload: z.object({
        ...base,
        activationId: z.uuid(),
        unitId: z.uuid().nullable(),
        status: washActivationStatusSchema,
        source: z.enum(["POS", "APP", "WEB"]),
    }),
});
export const washCreditNegativeBalanceV1 = defineEvent({
    type: "wash.credit.negative_balance",
    version: 1,
    description: "Self-servis kredisi eksiye düştü (çevrimdışı çift kullanım — kullanım reddedilmedi)",
    realtime: ["tenant"],
    payload: z.object({ ...base, creditId: z.uuid(), balanceSeconds: z.string().regex(/^-?\d{1,15}$/) }),
});
export const washWorkOrderStatusChangedV1 = defineEvent({
    type: "wash.work_order.status_changed",
    version: 1,
    description: "El yıkama iş emrinin durumu değişti (sıra ekranı)",
    realtime: ["station"],
    payload: z.object({
        ...base,
        workOrderId: z.uuid(),
        orderNo: z.string(),
        from: washWorkOrderStatusSchema.nullable(),
        to: washWorkOrderStatusSchema,
    }),
});
export const washWorkOrderReadyNotifiedV1 = defineEvent({
    type: "wash.work_order.ready_notified",
    version: 1,
    description: "İş emri hazır — müşteriye işlemsel SMS gönderildi / gönderilemedi",
    realtime: ["station"],
    payload: z.object({ ...base, workOrderId: z.uuid(), result: z.enum(["SENT", "FAILED", "NO_PHONE"]) }),
});
export const washAppointmentChangedV1 = defineEvent({
    type: "wash.appointment.changed",
    version: 1,
    description: "El yıkama randevusu alındı / iptal edildi / geldi / gelmedi",
    realtime: ["station"],
    payload: z.object({
        ...base,
        appointmentId: z.uuid(),
        unitId: z.uuid(),
        status: z.enum(["BOOKED", "CHECKED_IN", "CANCELLED", "NO_SHOW"]),
        startsAt: z.iso.datetime({ offset: true }),
    }),
});
//# sourceMappingURL=wash.v1.js.map